import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
	API_URL,
	scroll,
	isFieldError,
	getValFromLS,
	setValToLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Steps from "./Steps";

/* use as default notice when needed
  type: "notice",
  text: "Sporting Clay Tournament is no longer available",
*/

function fmtNameTeams(name, total, foursome) {
	const teams = total / foursome;
	if (teams === 1) {
		return `${name} (${teams} team)`;
	} else {
		return `${name} (${teams} teams)`;
	}
}

const RegAllocations = () => {
	const [details, setDetails] = useState({});
	const [allocation, setAllocation] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [msg2, setMsg2] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [notice] = useState({});

	const history = useHistory();
	const formElement = useRef(null);

	useEffect(() => {
		const init = () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				let orderFromLS = JSON.parse(getValFromLS("order", true));
				if (orderFromLS.level.golf === 0) {
					orderFromLS.allocation = {
						golf: 0,
						sporting: 0,
						welcome: orderFromLS.level.welcome,
						gift: orderFromLS.level.gift,
					};
					setValToLS("order", JSON.stringify(orderFromLS), true);

					history.push("/registration/logo");
				} else {
					let addonGolf = 0;
					let addonWelcome = 0;
					let addonGift = 0;

					if (orderFromLS.addons.length > 0) {
						orderFromLS.addons.forEach((addon) => {
							addonGolf = addonGolf + addon.qty * addon.golf;
							addonWelcome = addonWelcome + addon.qty * addon.welcome;
							addonGift = addonGift + addon.qty * addon.gift;
						});
					}

					const foursome = orderFromLS.level.golf === 2 ? 2 : 4;
					const totalTeams = (orderFromLS.level.golf + addonGolf) / foursome;
					setDetails({
						levelName: orderFromLS.level.name,
						golf: orderFromLS.level.golf + addonGolf,
						foursome,
						totalTeams,
						welcome: orderFromLS.level.welcome + addonWelcome,
						gift: orderFromLS.level.gift + addonGift,
					});
					setAlert({});
					scroll();
				}
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleClick = () => {
		const allocatedAmt = names.allocatedAmt
			? names.allocatedAmt.replace(/\$|,/g, "")
			: "";

		if (!names.allocatedName || !allocatedAmt) {
			setMsg2({
				type: "error",
				text: "Please select an allocation name and number of teams.",
			});

			return false;
		} else {
			let array = allocation;
			let foundIndex = null;
			array.forEach((item, index) => {
				if (item.name === names.allocatedName) {
					foundIndex = index;
				}
			});

			if (foundIndex !== null) {
				array[foundIndex] = {
					id: names.allocatedName === "Golf" ? "golf" : "sporting",
					name: `${names.allocatedName}`,
					amt: parseInt(allocatedAmt, 10) * details.foursome,
				};
			} else {
				array.push({
					id: names.allocatedName === "Golf" ? "golf" : "sporting",
					name: `${names.allocatedName}`,
					amt: parseInt(allocatedAmt, 10) * details.foursome,
				});
			}

			let allocationTotal = 0;
			array.forEach((item) => {
				allocationTotal = allocationTotal + item.amt;
			});
			setAllocation(array);
			setNames((names) => ({
				...names,
				allocationTotal,
				allocatedName: "",
				allocatedAmt: "",
			}));
			setMsg2({});

			formElement.current.allocatedName.value = "";
			formElement.current.allocatedAmt.value = "";
		}
	};

	const handleRemove = (index) => {
		let array = allocation;
		array.splice(index, 1);

		let allocationTotal = 0;
		array.forEach((item) => {
			allocationTotal = allocationTotal + item.amt;
		});
		setAllocation(array);
		setNames((names) => ({
			...names,
			allocationTotal,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationAllocations`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("golf", details.golf);
		data.append("allocation", JSON.stringify(allocation));
		data.append("auth", getValFromLS("auth", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				let orderFromLS = JSON.parse(getValFromLS("order", true));
				orderFromLS.allocation = {
					golf: json.golf,
					sporting: json.sporting,
					welcome: details.welcome,
					gift: details.gift,
				};
				setValToLS("order", JSON.stringify(orderFromLS), true);

				history.push("/registration/logo");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>3</h1>
							<div>
								<p>
									Please indicate how you would like to allot your total playing
									spots for golf foursomes and sporting clay squads. If you have
									any questions, please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<div className="spacer"></div>

						{notice.type && <Notice data={notice} />}

						<h3 style={{ marginTop: "25px", marginBottom: "25px" }}>
							Allocate Number of Golf & Sporting Clay Teams
						</h3>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
							style={{ paddingTop: "10px" }}
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "12.5px",
									fontSize: "1.1rem",
								}}
							>
								{fmtNameTeams(
									details.levelName,
									details.golf,
									details.foursome,
								)}
							</h4>

							<div
								style={{
									backgroundColor: "#fff",
									padding: "15px",
									border: "1px solid #ddd",
								}}
							>
								<div className="form-group">
									<Select
										name="allocatedName"
										label="Allocation Name"
										reqd={false}
										value={""}
										options={[{ id: "", name: "--" }].concat(
											["Golf", "Sporting Clays"]
												/* enable if sporting clays sold out.filter(
													(item) => item !== "Sporting Clays",
												)  */
												.map((item) => {
													return { id: item, name: item };
												}),
										)}
										update={handleUpdate}
										error={isFieldError(errors, "allocatedName")}
									/>

									<Select
										name="allocatedAmt"
										label="Number of Teams"
										reqd={false}
										value={""}
										options={[{ id: "", name: "--" }].concat(
											[
												...Array.from(
													Array(details.totalTeams),
													(e, i) => i + 1,
												),
											].map((item) => {
												return { id: item, name: item };
											}),
										)}
										update={handleUpdate}
										error={isFieldError(errors, "allocatedAmt")}
									/>
								</div>

								<div className="msg-submit">
									{msg2.type && <Msg data={msg2} />}
								</div>

								<div>
									<button
										type="button"
										className="btn-alt"
										onClick={() => handleClick()}
									>
										Add Allocation
									</button>
								</div>

								<table
									className="approved"
									style={{ marginTop: "25px", marginBottom: "5px" }}
								>
									<thead>
										<tr>
											<th className="left" style={{ width: "65%" }}>
												Allocation Name
											</th>
											<th style={{ width: "20%" }}>Total Spots</th>
										</tr>
									</thead>
									{allocation.length > 0 ? (
										<tbody>
											{allocation.map((item, index) => {
												return (
													<tr key={index}>
														<td className="left">
															<div className="item">
																<span>
																	{fmtNameTeams(
																		item.name,
																		item.amt,
																		details.foursome,
																	)}
																</span>
																<button
																	type="button"
																	className="naked"
																	onClick={() => handleRemove(index)}
																>
																	<i className="fa fa-trash fa-md error" />
																</button>
															</div>
														</td>
														<td className="right">{item.amt}</td>
													</tr>
												);
											})}
										</tbody>
									) : (
										<tbody>
											<tr>
												<td
													className="center working"
													colSpan="3"
													style={{
														paddingTop: "7.5px",
														paddingBottom: "7.5px",
													}}
												>
													-- No Allocations Selected --
												</td>
											</tr>
										</tbody>
									)}

									<tfoot>
										<tr>
											<td className="right">
												{fmtNameTeams(
													details.levelName,
													details.golf,
													details.foursome,
												)}
											</td>
											<td className="right">{details.golf}</td>
										</tr>
										{allocation.length > 0 && (
											<tr>
												<td className="right">Difference</td>
												<td className="right">
													{details.golf - names.allocationTotal}
												</td>
											</tr>
										)}
									</tfoot>
								</table>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Submit Allocations & Continue" />
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={3} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegAllocations;
